import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { RENTALS_ACTIONS, RENTALS_TYPES } from "./actions";
import {
  getRental as APIgetRental,
  getRentals as APIgetRentals,
  createRental as APIcreateRental,
  updateRental as APIupdateRental,
  deleteRental as APIdeleteRental
} from "../../services/api/rentals";
import { navigateTo } from "../navigation/saga";
import { rentalsEvent, rentalsFilters } from "./selectors";

export function* watchRentalsActions() {
  yield all([takeEvery(RENTALS_TYPES.LOAD_ALL_REQUEST, getRentals)]);
  yield all([takeEvery(RENTALS_TYPES.LOAD_REQUEST, getRental)]);
  yield all([takeEvery(RENTALS_TYPES.CREATE_REQUEST, createRental)]);
  yield all([takeEvery(RENTALS_TYPES.UPDATE_REQUEST, updateRental)]);
  yield all([takeEvery(RENTALS_TYPES.DELETE_REQUEST, deleteRental)]);
  yield all([takeEvery(RENTALS_TYPES.CREATE_SUCCESS, getRentals)]);
  yield all([takeEvery(RENTALS_TYPES.DELETE_SUCCESS, getRentals)]);
}

function* getRentals(action) {
  let { filters, eventId } = action.payload;

  try {
    if (filters) {
      yield put(RENTALS_ACTIONS.updateFilters(filters));
    } else {
      filters = yield select(rentalsFilters);
    }

    eventId = yield call(checkEventId, eventId);

    const rentals = yield call(APIgetRentals, eventId, filters);
    yield put(RENTALS_ACTIONS.loadAllSuccess(rentals));
  } catch (e) {
    yield put(RENTALS_ACTIONS.loadAllFailure(e));
  }
}

function* getRental(action) {
  const { id } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const rental = yield call(APIgetRental, eventId, id);
    yield put(RENTALS_ACTIONS.loadSuccess(rental));
  } catch (e) {
    yield put(RENTALS_ACTIONS.loadFailure(e));
  }
}

function* createRental(action) {
  const { values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const rental = yield call(APIcreateRental, eventId, values);
    yield put(RENTALS_ACTIONS.createSuccess(rental));
    yield call(navigateTo, "/admin/rentals");
  } catch (e) {
    yield put(RENTALS_ACTIONS.createFailure(e));
  }
}

function* updateRental(action) {
  const { id, values } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const rental = yield call(APIupdateRental, eventId, id, values);
    yield put(RENTALS_ACTIONS.updateSuccess(rental));
    yield call(navigateTo, "/admin/rentals");
  } catch (e) {
    yield put(RENTALS_ACTIONS.updateFailure(e));
  }
}

function* deleteRental(action) {
  const { id } = action.payload;
  try {
    const eventId = yield call(checkEventId, action.payload.eventId);
    const rental = yield call(APIdeleteRental, eventId, id);
    yield put(RENTALS_ACTIONS.deleteSuccess(rental));
  } catch (e) {
    yield put(RENTALS_ACTIONS.deleteFailure(e));
  }
}

function* checkEventId(eventId) {
  if (eventId) {
    yield put(RENTALS_ACTIONS.updateEvent(eventId));
  } else {
    eventId = yield select(rentalsEvent);
  }

  return eventId;
}
